module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/5illustrations#illustrations"
    }
  }, [_vm._v("LIST OF ILLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/6start#preface"
    }
  }, [_vm._v("PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/7introduction#introduction"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9chap1#chap1"
    }
  }, [_vm._v("1. “THEIR MANNERS ARE DECOROUS AND PRAISEWORTHY”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/10chap2#chap2"
    }
  }, [_vm._v("2. THE LONG WALK OF THE NAVAHOS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/11chap3#chap3"
    }
  }, [_vm._v("3. LITTLE CROW’S WAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/12page67#chap4"
    }
  }, [_vm._v("4. WAR COMES TO THE CHEYENNES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/13chap5#chap5"
    }
  }, [_vm._v("5. POWDER RIVER INVASION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/14page121#chap6"
    }
  }, [_vm._v("6. RED CLOUD’S WAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/15chap7#chap7"
    }
  }, [_vm._v("7. “THE ONLY GOOD INDIAN IS A DEAD INDIAN”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/16chap8#chap8"
    }
  }, [_vm._v("8. THE RISE AND FALL OF DONEHOGAWA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/17chap9#chap9"
    }
  }, [_vm._v("9. COCHISE AND THE APACHE GUERRILLAS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/18page219#chap10"
    }
  }, [_vm._v("10. THE ORDEAL OF CAPTAIN JACK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/19chap11#chap11"
    }
  }, [_vm._v("11. THE WAR TO SAVE THE BUFFALO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/20page273#chap12"
    }
  }, [_vm._v("12. THE WAR FOR THE BLACK HILLS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/21page315#chap13"
    }
  }, [_vm._v("13. THE FLIGHT OF THE NEZ PERCÉS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/22chap14#chap14"
    }
  }, [_vm._v("14. CHEYENNE EXODUS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/23page351#chap15"
    }
  }, [_vm._v("15. STANDING BEAR BECOMES A PERSON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/24chap16#chap16"
    }
  }, [_vm._v("16. “THE UTES MUST GO!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/25page391#chap17"
    }
  }, [_vm._v("17. THE LAST OF THE APACHE CHIEFS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/26page415#chap18"
    }
  }, [_vm._v("18. DANCE OF THE GHOSTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/27chap19#chap19"
    }
  }, [_vm._v("19. WOUNDED KNEE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/28biography#biography"
    }
  }, [_vm._v("A BIOGRAPHY OF DEE BROWN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/41page451#chap20"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/42chap21#chap21"
    }
  }, [_vm._v("BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/43chap22#chap22"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a5bb1f9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4-TOC.vue
// module id = 72
// module chunks = 0